<template>
  <div
    class="w-full bg-surface-light border border-surface-grey px-4 py-4 md:py-5 rounded-md"
  >
    <component
      :is="$slots.default ? 'button' : 'div'"
      :class="[
        'flex items-center w-full text-left',
        {
          'cursor-pointer': $slots.default,
        },
      ]"
      type="button"
      v-bind="
        $slots.default
          ? { 'aria-expanded': open, 'aria-controls': 'infobox-content' }
          : {}
      "
      @click="$slots.default ? (open = !open) : undefined"
    >
      <div class="flex flex-col gap-2 md:flex-row md:gap-4">
        <div class="flex items-center gap-2">
          <slot name="icon" />
          <div class="font-semibold min-w-20">
            {{ title }}
          </div>
        </div>

        <div class="line-clamp-1">
          <slot name="description" />
        </div>
      </div>

      <DropdownIcon
        v-if="$slots.default"
        :class="[
          'ml-auto mr-2 w-3 h-3 transition-transform',
          open ? 'rotate-180' : '',
        ]"
      />
    </component>

    <div v-if="$slots.default">
      <BaseSlideTransition>
        <div v-show="open">
          <div class="pt-5">
            <slot />
          </div>
        </div>
      </BaseSlideTransition>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue';

  import DropdownIcon from '../icons/DropdownIcon.vue';
  import BaseSlideTransition from './BaseSlideTransition.vue';

  defineProps<{
    title: string;
    icon?: string;
  }>();

  const emit = defineEmits(['open']);

  const open = ref(false);

  watch(open, val => {
    emit('open', val);
  });
</script>
